import { render, staticRenderFns } from "./News260702ENG.vue?vue&type=template&id=2f62d654&scoped=true&"
import script from "./News260702ENG.vue?vue&type=script&lang=js&"
export * from "./News260702ENG.vue?vue&type=script&lang=js&"
import style0 from "./News260702ENG.vue?vue&type=style&index=0&id=2f62d654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62d654",
  null
  
)

export default component.exports